<template>
    <span class="rectangular-element">
        <div class="d-flex fill-height rectangular-element-content">
            <div>
                <div>
                    <div class="d-flex justify-space-between">
                        <h3>{{title}}</h3>
                        <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn dark icon v-bind="attrs" v-on="on" class="hidden-mobile">
                                    <v-icon class="grey_">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-for="(item, i) in actions" :key="i" @click="item.callback(id)" class="cursor-pointer last-child-red">
                                    <v-list-item-icon>
                                        <v-icon>{{item.icon}}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{item.title}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    <h4>{{formatDate(date)}}</h4>
                    <h5>{{guide}}</h5>
                </div>
                <v-btn :to="linkresult" class="mt-4 text-none absolute answers">Réponses : 4 </v-btn>
                <v-btn class="mt-4 text-none absolute participations">Participations : {{contributions}} </v-btn>
                <v-btn class="mt-4 text-none absolute stock">Stock : {{count}} </v-btn>
                <v-btn class="mt-4 primary-button absolute" @click="publish()">Publier</v-btn>
            </div>
            <v-menu bottom left class="hidden-desktop">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on" class="ma-auto hidden-desktop">
                        <v-icon v-if="!mobileMenu" @click="mobileMenu = true" class="grey_">mdi-chevron-down</v-icon>
                        <v-icon v-else @click="mobileMenu = false" class="grey_">mdi-chevron-up</v-icon>
                    </v-btn>
                </template>
            </v-menu>
        </div>
        <v-expand-transition>
            <div v-if="mobileMenu" class="justify-center hidden-desktop">
                <v-list class="d-flex flex-wrap">
                    <v-list-item v-for="(item, i) in actions" :key="i" @click="item.callback(id)" class="cursor-pointer last-child-red flex-column">
                        <v-list-item-icon>
                            <v-icon>{{item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{item.title}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-expand-transition>
    </span>
</template>

<script>
import axios from 'axios'
export default {
    name: 'RectangularElement',
    props: ['type', 'title', 'date', 'guide', 'actions', 'linkresult', 'count', 'contributions', 'id', 'publishUrl', 'publishObject'],
    data: () => {
        return {
            mobileMenu: false
        }
    },
    methods: {
        // FORMAT DATE
        formatDate (date) {
            if (!date) return null
            const d = new Date(date)
            const year = d.getFullYear()
            const month = d.getMonth()
            const day = d.getDate()
            return `${day < 10 ? 0 : ''}${day}/${month + 1 < 10 ? 0 : ''}${month + 1}/${year}`
        },
        // PUBLISH ELEMENT
        async publish () {
            try {
                this.$store.dispatch('loading')
                this.publishObject.activated = true
                await axios.put(this.publishUrl, this.publishObject)
                this.$emit('update')
            } catch (e) {
                alert('Une erreur est survenue, veuillez réessayer.')
                console.log(e)
            } finally {
                this.$store.dispatch('stop_loading')
            }
        }
    }
}
</script>